// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"bd2e761b","497":"9c659a26","578":"c0b9ef88","641":"cf2c2b53","705":"7048b38a","778":"1a2a3ec7","884":"0f168591"}[chunkId] + ".chunk.js";
};